import { useState, useEffect } from 'react';
import classnames from 'classnames';

import { Card } from 'ui-components/components/card/card';
import { emptyArray } from 'ui-components/default-props/empty';

import { HAS_CONFIRMED_DANGEROUS_GOODS, SELECT_PRODUCTS_STEP, SELECTED_PRODUCTS } from '../constants';
import { SelectProductsEdit } from './select-products-edit';
import { SelectProductsReadOnly } from './select-products-read-only';
import { useAdvancedShippingNoticeContext } from '../../advanced-shipping-notice-context';
import { StepCardBody } from '../step-card-body';
import { StepCardTitle } from '../step-card-title';
import { messages } from './messages';
import styles from '../step-card-body.module.less';

const initialState = {
  [SELECTED_PRODUCTS]: emptyArray,
  [HAS_CONFIRMED_DANGEROUS_GOODS]: false,
};

export const SelectProductsCard = () => {
  const { isEditingStepWithId, savedPayloads, isDraft, isCompleteStepWithId, isProductStepCollapsed, setIsProductStepCollapsed } =
    useAdvancedShippingNoticeContext();
  const isEditing = isEditingStepWithId(SELECT_PRODUCTS_STEP) && isDraft;
  const isComplete = isCompleteStepWithId(SELECT_PRODUCTS_STEP);
  const [stepPayload, setStepPayload] = useState(savedPayloads[SELECT_PRODUCTS_STEP] || initialState);
  const isDisabled = !isDraft || !(isEditing || isComplete);

  useEffect(() => {
    if (savedPayloads[SELECT_PRODUCTS_STEP]) {
      setStepPayload(savedPayloads[SELECT_PRODUCTS_STEP]);
    }
  }, [savedPayloads]);

  return (
    <Card
      className={classnames(styles['card-wrapper'], {
        [styles.disabled]: isDisabled,
      })}
    >
      <StepCardTitle
        isCollapsed={isProductStepCollapsed}
        setIsCollapsed={setIsProductStepCollapsed}
        stepId={SELECT_PRODUCTS_STEP}
        stepPayload={stepPayload}
        titleMessageDescriptor={messages.selectProductsTitle}
      />
      {!isProductStepCollapsed && (
        <StepCardBody stepId={SELECT_PRODUCTS_STEP}>
          {isEditing ? <SelectProductsEdit setStepPayload={setStepPayload} stepPayload={stepPayload} /> : null}
          {!isEditing && <SelectProductsReadOnly stepPayload={stepPayload} />}
        </StepCardBody>
      )}
    </Card>
  );
};
